<template>
  <el-row class="navbar" :style="{ left: left, width: `calc(100% - ${left})` }">
    <el-col :span="6" class="navbar_left">
      <hamburger
        class="hamburger-container"
        :toggleClick="toggleSideBar"
        :isActive="sidebar.opened"
      ></hamburger>
      <el-autocomplete
        class="inline-input"
        v-model="queryData"
        clearable
        :fetch-suggestions="querySearch"
        placeholder="请输入菜单名称"
        @select="handleSelect"
      ></el-autocomplete>
    </el-col>
    <el-col :span="13">
      <el-tabs
        class="navbar_center"
        :value="activeTab"
        @tab-click="handleClick"
      >
        <template v-for="item in menus">
          <el-tab-pane :label="item.permName" :name="item.url" :key="item.url">
          </el-tab-pane>
        </template>
      </el-tabs>
      <!-- <el-menu
        class="navbar_center"
        :default-active="$route.path"
        mode="horizontal"
        router
      >
        <template v-for="item in menus">
          <el-menu-item
            :key="item.url"
            :index="
              item.children ? item.url + '/' + item.children[0].url : item.url
            "
          >
            {{ item.permName }}
          </el-menu-item>
        </template>
      </el-menu> -->
    </el-col>
    <el-col :span="5" class="navbar_right">
      <span class="avatar_content">
        <el-avatar icon="el-icon-user-solid"></el-avatar>
        <span>操作人员&nbsp;&nbsp;&nbsp;</span>
      </span>
      <span class="logout" @click="logout">
        <svg-icon icon-class="off"></svg-icon>
        <span>退出</span>
      </span>
    </el-col>
  </el-row>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "menus"]),
    left() {
      return this.sidebar.opened ? "180px" : "36px";
    },
    activeTab() {
      const path = this.$route.path.split("/");
      const len = path.length - 1;
      console.log(this.$route.path);
      return len === 1 ? this.$route.path : `/${path[1]}`;
    }
  },
  data() {
    return {
      queryData: ""
    };
  },
  methods: {
    querySearch(queryString, cb) {
      function getMenuLists(menus, url = false) {
        let result = [];
        menus.forEach(e => {
          let json = {
            value: e.permName,
            url: url ? url + "/" + e.url : e.url
          };
          if (e.children && e.children.length > 0) {
            const data = getMenuLists(e.children, e.url);
            result.push(...data);
          }
          result.push(json);
        });
        return result;
      }
      var restaurants = getMenuLists(this.menus);
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return res => {
        return (
          res.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1
        );
      };
    },
    handleSelect(item) {
      console.log(this.$route.path, item.url);
      if (this.$route.path !== item.url) {
        this.$router.push(item.url);
      }
      console.log(item);
    },
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    logout() {
      this.$confirm("确认退出?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        })
        .catch(() => {});
    },
    handleClick(tab) {
      this.$router.push(tab.name);
      console.log(tab.name);
    }
  }
};
</script>
<style lang="scss">
.navbar {
  .navbar_left {
    .el-autocomplete {
      width: calc(100% - 70px);
      .el-input__inner {
        border-radius: 20px;
        height: 35px;
        line-height: 35px;
        // border-color: #54b391;
        // background: #54b391;
      }
      // .el-input.is-active .el-input__inner,
      // .el-input__inner:focus {
      //   border-color: #54b391;
      // }
    }
  }
  .navbar_center {
    .el-tabs__nav-wrap::after {
      height: 0 !important;
    }
    .el-tabs__nav-next,
    .el-tabs__nav-prev {
      line-height: 55px !important;
    }
    .el-tabs__item.is-active,
    .el-tabs__item:hover {
      color: #008152;
    }
    .el-tabs__active-bar {
      height: 4px;
      background: #008152 !important;
    }

    // background: none !important;
    // border-bottom: none !important;
    // border-bottom: none !important;
    // .el-menu-item {
    //   line-height: 55px !important;
    //   height: 55px !important;
    //   &.is-active {
    //     border-width: 4px !important;
    //   }
    // }
  }
}
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 55px;
  line-height: 55px;
  border-radius: 0px !important;
  position: fixed;
  top: 0;
  width: 100%;
  padding-right: 15px;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 99999;
  .hamburger-container {
    float: left;
    padding: 0 10px;
  }
  .navbar_right {
    text-align: right;
  }
  .avatar_content {
    .el-avatar {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #008152;
      vertical-align: middle;
    }
  }
  .logout {
    cursor: pointer;
    color: #f56c6c;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue